import { CONFIRMED_GET_FOLLOWUPS, CONFIRMED_CREATE_FOLLOWUP_ACTION } from "./FollowUpType.js"

import { getFollowUps, createFollowUp, formatFollowUps } from "../../services/FollowUpService.js"

import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService.js"


function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey
  if (stateToken) return stateToken

  const storedUser = localStorage.getItem("userDetails")
  return storedUser ? JSON.parse(storedUser).token : null
}


export function getFollowUpAction(lead_id) {
  return async (dispatch, getState) => {
    if (!lead_id) {
      showErrorAlert("Lead ID not found", "error")
      return
    }

    try {
      // console.log("Fetching follow-ups for lead_id:", lead_id)
      const response = await getFollowUps(lead_id)
      // console.log("Follow-up API response:", response)

      if (response && response.status === 200 && response.data) {
        if (response.data.status === "success" && response.data.data) {
          const followUps = formatFollowUps(response.data.data)
          // console.log("Formatted follow-ups:", followUps)
          dispatch({
            type: CONFIRMED_GET_FOLLOWUPS,
            payload: followUps,
          })
        } else {
          // console.log("API returned unsuccessful status:", response.data)
          handleError("Failed to get follow-ups: Server error")
        }
      } else {
        // console.log("Invalid response structure:", response)
        handleError("Failed to get follow-ups: Network error")
      }
    } catch (error) {
      console.error("API Error:", error.response || error)
      showErrorAlert("Failed to get follow-ups")
    }
  }
}

export function createFollowUpAction(followUpData, lead_id) {
  return async (dispatch, getState) => {
    if (!lead_id) {
      handleError("Lead ID not found", "error")
      return
    }

    const singleFollowUp = {
      lead_id,
      followup_reason: followUpData.reason, 
      next_action: followUpData.next_action,
      next_followup_date: followUpData.next_follow_up_date,
      next_followup_time: followUpData.next_followup_time, 
    }

    // console.log("Creating follow-up with data:", singleFollowUp)

    try {
      const response = await createFollowUp(singleFollowUp)
      // console.log("Create Follow-Up Response:", response)

      if (response && response.status === 200 && response.data) {
        if (response.data.status === "success") {
          dispatch({
            type: CONFIRMED_CREATE_FOLLOWUP_ACTION,
            payload: {
              ...singleFollowUp,
              followup_id: response.data.followup_id || Date.now(), 
              created_at: new Date().toISOString(),
            },
          })
          handleSuccess("Follow-up created successfully!", "success")
          return { success: true }
        } else {
          showErrorAlert("Failed to create follow-up: " + (response.data.message || "Server error"))
          return { success: false }
        }
      } else {
        showErrorAlert("Failed to create follow-up")
        return { success: false }
      }
    } catch (error) {
      console.error("API Error:", error.response || error)
      showErrorAlert("Failed to create follow-up: " + (error.message || "Network error"))
      return { success: false }
    }
  }
}
